import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { deviceCategories, devices } from "@/mocks/installData";

export default function Devices() {
  const [activeCategory, setActiveCategory] = useState("all");
  const filtered =
    activeCategory === "all" ? devices : devices.filter((d) => d.category === activeCategory);

  return (
    <section id="devices" className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Compatibility"
          title="支持的设备与最小系统要求"
          desc="按设备类型筛选，快速确认手中的手机、电视或电脑是否在适配范围内。若系统版本低于标注要求，建议先升级系统再安装。"
        />

        <div className="max-w-6xl mx-auto mt-10">
          <div className="flex flex-wrap justify-center gap-2">
            {deviceCategories.map((cat) => (
              <button
                key={cat.id}
                type="button"
                onClick={() => setActiveCategory(cat.id)}
                className={`px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors border ${
                  activeCategory === cat.id
                    ? "bg-secondary-500 text-background-50 border-secondary-500"
                    : "bg-background-50 text-foreground-700 border-background-200 hover:border-secondary-300"
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {filtered.map((device) => (
              <article
                key={device.id}
                className="bg-background-50 border border-background-200 rounded-lg p-5 flex flex-col gap-3"
              >
                <div className="flex items-center justify-between">
                  <div className="w-11 h-11 rounded-lg bg-secondary-100 text-secondary-700 flex items-center justify-center">
                    <i className={`${device.icon} text-xl`}></i>
                  </div>
                  <span className="text-xs text-foreground-500 font-label bg-background-100 px-2.5 py-1 rounded-full">
                    {device.categoryLabel}
                  </span>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  {device.name}
                </h3>
                <div className="flex flex-col gap-1.5 text-sm text-foreground-600">
                  <span className="inline-flex items-center gap-2">
                    <i className="ri-settings-5-line text-foreground-400"></i>
                    {device.system}
                  </span>
                  <span className="inline-flex items-center gap-2">
                    <i className="ri-install-line text-foreground-400"></i>
                    {device.packageType}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed border-t border-background-100 pt-3">
                  {device.note}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}